import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router } from '@angular/router';

declare var $: any

@Component({
  selector: 'app-question-and-answer',
  templateUrl: './question-and-answer.component.html',
  styleUrls: ['./question-and-answer.component.scss']
})
export class QuestionAndAnswerComponent implements OnInit {

  notFoundResult = false
  public Search: string = null;
  faqList: any = []
  categoryList: any = []

  config: any = {}
  isCrisis: boolean = false

  searchType = "k"

  filterWord = ""

  menuEnabled = false

  @ViewChildren('faq') faq: QueryList<any>;
  constructor(
    private util: UtilService,
    private api: ApiService,
    private router: Router
  ) { }

  async ngOnInit() {

    let thisTs = this

    this.util.ShowWaiting(true)

    this.config = await this.api.get("master", "configuration")
    if (this.config == null || this.config.length == 0) {
      this.util.ErrorDialog("ไม่สามารถอ่านข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่")
      return
    }

    this.isCrisis = this.config[0].dpa_crisisflag ? true : false

    let menuList:any = await this.api.get("master", "customerPortalMenuSetting")
    let thisMenu: any = this.util.getMenuObj(menuList, "03", this.isCrisis)
    if(!thisMenu.show){
      this.util.ShowWaiting(false)
      setTimeout(() => {
        this.router.navigate(["mainmenu/index"])
      }, 500);
      return
    }
    else {
      this.menuEnabled = true
    }


    await this.intiData()

    $('#filter').on('keyup', function () {
      thisTs.filterQA()
    });

    $('input[type=search]').on('search', function () {
      thisTs.filterQA()
    });
  }

  async intiData() {

    let c: any = await this.api.get("master", "knowledgebasecategory")
    this.categoryList = c.filter((k: any) => {
      return k.dpa_isfaq
    })

    this.categoryList.forEach(async (c: any) => {
      let para = "dpa_categoryid=" + c.dpa_kmcategoryid.toUpperCase() + "&dpa_publishstatus=true&dpa_isdisplayoncustomerportal=true&dpa_iscrisis=" + this.isCrisis.toString()
      c.qList = await this.api.get("master", "knowledgeBase", para)
      if(c.qList != null && c.qList.length > 0){
        c.qList.forEach((q: any) => {
          if (q.attachfilelist != null && q.attachfilelist.length > 0) {
            let baseUrl = this.util.baseUrl()
            let att: any = q.attachfilelist.map((a: any) => {
              return '<a class="mr-3" target="_blank" href="' + baseUrl + '/downloadFile?file=' + a.annotationid + '">' + a.filename + "</a>"
            })
            q.dpa_attch = '<label class="mr-3">ไฟล์แนบ:</label>' + att.join("")
          }
          else {
            q.dpa_attch = ''
          }
        });
      }
    });
  }

  filterQA() {
    if (this.filterWord == null || this.filterWord.length < 3) {
      $(".question").each((index: number, element: object) => {
        //let question = $(element).closest(".question")[0]
        $(element).removeClass("sr-only")
      })
      this.Search = ""
      this.notFoundResult = false
      this.collapsAll()
    }
    else {
      let isFound = false
      if (this.searchType == "k") {
        $(".question").each((index: number, element: object) => {
          if ($(element).find(".content").attr("title").toLowerCase().includes(this.filterWord.toLowerCase())) {
  
            this.Search = this.filterWord;
            this.showFaq(element)
            isFound = true
          }
          else {
            let question = $(element).closest(".question")[0]
            $(question).addClass("sr-only")
          }
        })
      }
      else if (this.searchType == "c") {
        $(".question").each((index: number, element: object) => {
          if ($($(element).find(".collapsible-question")[0]).text().toLowerCase().includes(this.filterWord.toLowerCase()) ||
            $(element).find(".content").text().toLowerCase().includes(this.filterWord.toLowerCase())) {
  
            this.Search = this.filterWord;
            this.showFaq(element)
            isFound = true
          }
          else {
            let question = $(element).closest(".question")[0]
            $(question).addClass("sr-only")
          }
        })
      }
      else {//if (this.searchType == "a") {
        $(".question").each((index: number, element: object) => {
          if ($(element).find(".content").attr("title").toLowerCase().includes(this.filterWord.toLowerCase()) ||
            $($(element).find(".collapsible-question")[0]).text().toLowerCase().includes(this.filterWord.toLowerCase()) ||
            $(element).find(".content").text().toLowerCase().includes(this.filterWord.toLowerCase())) {
  
            this.Search = this.filterWord;
            this.showFaq(element)
            isFound = true
          }
          else {
            let question = $(element).closest(".question")[0]
            $(question).addClass("sr-only")
          }
        })
      }

      
      this.notFoundResult = !isFound
    }
  }

  collapsAll() {
    $(".collapsible").removeClass("active");
    $(".collapsible").next().slideUp();

    var body = $("html, body");
    body.stop().animate({ scrollTop: 0 }, 300, 'swing', function () {
    });
  }

  onParentClick(element: any) {
    element.classList.toggle("active");
    var content = element.nextElementSibling;
    $(content).slideToggle();
  }

  onBtnLabelClick(element: any) {
    let btn = $(element).closest("button")[0]
    btn.classList.toggle("active");
    var content = btn.nextElementSibling;
    $(content).slideToggle();

  }


  ngAfterViewInit() {
    this.faq.changes.subscribe(t => {
      this.util.ShowWaiting(false)
    })
  }

  ngForRendred() {
    this.util.ShowWaiting(false)
  }

  showFaq(element: object){
    let question = $(element).closest(".question")[0]
    $(question).removeClass("sr-only")

    let content = $(element).find(".content")[0]
    $(content).slideDown()

    let btn = $(element).find("button")[0]
    $(btn).addClass("active")

    setTimeout(() => {
      let parent = $(element).closest('.content')[0]
      $(parent).slideDown()
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/question-and-answer/question-and-answer.component.ts